<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="网课名称">
          <el-input placeholder="请输入网课名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item label="网课分类" >
        <el-select id="searchType" v-model="formInline.ocourse_category_code" class="searchType">
          <el-option v-for="(item,index) in ocourse_category" :key="index" :label="item.name" :value="item.code"></el-option>
                
        </el-select>
      </el-form-item>
    
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button type="primary" icon="el-icon" @click="reast">重置</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加网课</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="网课名称"></el-table-column>

            <el-table-column prop="short_intro" label="短介绍" width="180">
              <template slot-scope="scope">
               <div style="height: 60px; overflow: auto;">
                {{ scope.row.short_intro }}

               </div>
              </template>

            </el-table-column>

            <el-table-column  label="分类" width="120">
              <template slot-scope="scope">
               {{ scope.row.ocourse_category.name }}
              </template>
            </el-table-column>

            <el-table-column  label="网课介绍" width="100">
              <template slot-scope="scope">
                <el-button style="margin-left: 0px !important;margin-right: 10px;" @click="introClick(scope.row,'intro')" 
                type="text"    size="small">网课介绍</el-button>
               </template>
            </el-table-column>

            <el-table-column  label="图文" width="100">
              <template slot-scope="scope">
                <el-button style="margin-left: 0px !important;margin-right: 10px;" @click="introClick(scope.row,'image_text')" 
                type="text"   size="small">图文</el-button>
               </template>
            </el-table-column>

            <el-table-column  label="课程目录" width="100">
              <template slot-scope="scope">
                <el-button style="margin-left: 0px !important;margin-right: 10px;" @click="cClick(scope.row)" 
                type="text"   size="small">课程目录</el-button>
               </template>
            </el-table-column>


            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ocourse_id="ocourse_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

    <Tz :open_add="open_tz" :code="code" :ocourse_id="ocourse_id" :obj="obj"  v-if="open_tz"   @close="closeTz"></Tz>
    <Catalogue :open="open_c" :ocourse_id="ocourse_id"   v-if="open_c"   @close="closeC"></Catalogue>
  
  </div>
</template>

<script>
  import OcourseApi from '@/api/ocourse.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Tz from './part/tz.vue';
  import Catalogue from './catalogue/index.vue';
  export default {
    components: {
      Add,
      Edit,
      Tz,
      Catalogue,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          ocourse_category_code:""
        },

        open_add:false,
        open_edit:false,
        ocourse_id:"",
        dialogVisible:false,
        ocourse_category:[],
        open_tz:false,
        obj:{},
        code:"",
        open_c:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
      this.getSetting();
    },
    methods: {
      reast(){
        this. formInline= {
          search:"",
          ocourse_category_code:""
        }
        this.getTableList();
      },
      introClick(row,code){
        this.open_tz=true;
        this.obj = row
        this.code = code
        this.ocourse_id = row.ocourse_id;
      },
      cClick(row){
        this.open_c=true;
        this.ocourse_id = row.ocourse_id;
      },
      closeTz(e){
      this.open_tz=false;

      this.getTableList();
    },
    closeC(e){
      this.open_c=false;

      this.getTableList();
    },
      getSetting(){
      var self = this;
      self.getSetting_common({
        "item":'ocourse'

      },function(data){
          console.log('data',data)
          self.ocourse_category = data.vars.values.ocourse_category
      })
    },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//网课标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        OcourseApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.ocourse_id = row.ocourse_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            OcourseApi.del(
              {
                ocourse_id: row.ocourse_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ocourse/index/index.vue